import React, {createContext, useEffect, useState} from "react";
import Cookies from "js-cookie";
import axios, {AxiosRequestConfig} from "axios";

import api from "../../utils/api";
import ExpiredToken from "../../components/Static/Error/ExpiredToken";
import { stringify } from 'qs'
import {useRouter} from "../../utils/hooks/useRouter";
import {useLocation} from "react-router-dom";
import {serviceOptions as servicePageBuilderOptions} from "../page-builder/serviceOptions";
import {serviceOptions as servicePageAuthOptions} from "../auth/serviceOptions";
import {serviceOptions as servicePageMerchantsOptions} from "../merchants/serviceOptions";
export const AuthContext = createContext<{
  logIn?: ({ authCode, callback }: any) => void;
  setExpiredToken?: (value: boolean) => void;
}>({});

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const [isExpiredToken, setExpiredToken] = useState(false);
  const [token, setToken] = useState(Cookies.get("mykiot_access_token"))
  const [axiosConfig, setAxiosConfig] = useState<AxiosRequestConfig>({
    baseURL: process.env.REACT_APP_GATEWAY_API || 'http://localhost:3000/',
    timeout: 120000, // 2 phút
    paramsSerializer: (params:any) =>
        stringify(params, { arrayFormat: 'repeat' }),
  })
  servicePageBuilderOptions.axios = axios.create(axiosConfig)
  servicePageAuthOptions.axios = axios.create(axiosConfig)
  servicePageMerchantsOptions.axios = axios.create(axiosConfig)
  useEffect(() => {
    servicePageBuilderOptions.axios = axios.create(axiosConfig)
  }, [axiosConfig])
  useEffect(() => {

    if (token) {
      setAxiosConfig((prevConfig) => ({
        ...prevConfig,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }))
    }
  }, [pathname]);
  const logIn = ({ authCode, callback }: any) => {

    // console.log("auth_code", authCode);
    if (typeof authCode == "undefined") {
      return;
    }
    const pathname = window.location.href.slice(window.location.origin.length);
    if (!pathname) return;
    const pathArray = pathname.split("/");
    if (pathArray.length < 2) return;
    const platform = pathArray[1];
    console.log("platform",platform)
    api({ token: authCode })
      .get(`${process.env.REACT_APP_AUTH_API}/api/v1/login/${authCode}`, {
        params: { platform },
      })
      .then((response) => {
        const { data } = response;
        // console.log("response.data.", response.data);
        if (data && data.data && typeof data.data.access_token != "undefined") {
          const access_token = data.data.access_token;
          Cookies.set("mykiot_access_token", access_token);
          // set cookies
          Cookies.set("mykiot_platform", platform);
          Cookies.set("mykiot_merchant_id", data.data && data.data.merchant_id);
          Cookies.set("mykiot_branch_id", data.data && data.data.branch_id);

          localStorage.setItem("mykiot_access_token", access_token);
          localStorage.setItem("mykiot_platform", platform);
          localStorage.setItem("mykiot_merchant_id", data.data && data.data.merchant_id);
          localStorage.setItem("mykiot_branch_id", data.data && data.data.branch_id);


          setToken(access_token)
          axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;

          callback &&
            callback({
              status: true,
              accessToken: access_token,
            });
        }
      })
      .catch(({ errors }) => {
        console.log(errors);
        setExpiredToken(true);

        callback &&
          callback({
            status: false,
            errors: errors,
          });
      });
  };
  return (
    <AuthContext.Provider value={{ logIn, setExpiredToken }}>
      {isExpiredToken ? <ExpiredToken /> : children}
    </AuthContext.Provider>
  );
};
